import React from 'react'
import { useState } from 'react'
import { NumericFormat } from 'react-number-format'
import { isDisabled } from '../../utils'

export default function AppObjectFieldCurrency(props) {
  const { field, action, value, handleChange, hasChanged } = props
  console.log('AppObjectFieldCurrency rendered: ', props)

  const [localValue, setLocalValue] = useState(value)

  function handleInputChange(event) {
    console.log('AppObjectFieldCurrency.handleInputChange: ', event)
    let newLocalValue = ''
    if (event.target.value) {
      newLocalValue = event.target.value
    }
    setLocalValue(newLocalValue)
    handleChange(event, hasChanged)
  }

  if (isDisabled(action, field.behaviorType)) {
    let displayString = ''
    if (localValue) {
      const formatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' })
      displayString = formatter.format(localValue)
    }
    return (<span>{displayString}</span>)
  }

  return (
    <React.Fragment>
      <span style={{ fontWeight: 'bold', paddingRight: '5px' }}>$</span>
      <NumericFormat
        name={field.id}
        className='app-object-field-currency auto-width form-control'
        id={field.id}
        value={localValue}
        displayType={'input'}
        thousandSeparator={true}
        decimalScale={2}
        fixedDecimalScale={true}
        onChange={handleInputChange}
      />
    </React.Fragment>
  )
}
